<template>
  <b-form class="1w-100 form" @submit="onSubmit">


    <div class="air__utils__headingx">
      <div class="d-flex justify-content-between">
        <h5>Liquidação</h5>
      </div>
    </div>

    <b-row cols="4">
      <b-col>
        <b-form-group label="Tipo liquidação" label-for="Status">
          <a-select
            v-model="form.payoutType.idPayoutType"
            :required="true"
            ref="idPayoutType"
            :name="`idPayoutType${_uid}`"
          >
            <a-select-option value="null"> Selecione </a-select-option>
            <a-select-option
              :value="item.id"
              v-for="(item, index) in payoutTypeList"
              :key="`payoutType-${index}`"
            >
              {{ item.description }}
            </a-select-option>
          </a-select>
        </b-form-group>


        <b-btn
          @click="savePayoutType"
          variant="outline-primary"
          :disabled="loadingPayoutType"
          >Salvar
          <b-spinner
            small
            variant="primary"
            label="Spinning"
            v-show="loadingPayoutType"
          ></b-spinner>
        </b-btn>
        
    </b-col>
    </b-row>


    <div class="air__utils__heading mt-5">
      <div class="d-flex justify-content-between">
        <h5>Mercado Pago</h5>
      </div>
    </div>

<b-row cols="4">
<b-col v-if="form.idMercadoPagoStore">
        <b-form-group label="Codigo da Loja:" label-for="idMercadoPagoStore">
          <b-form-input
            id="idMercadoPagoStore"
            v-model="form.idMercadoPagoStore"
            disabled
            placeholder="Codigo da Loja"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col v-if="form.idMercadoPagoPos">
        <b-form-group label="Codigo do Caixa:" label-for="idMercadoPagoPos">
          <b-form-input
            id="idMercadoPagoPos"
            v-model="form.idMercadoPagoPos"
            disabled
            placeholder="Codigo do Caixa"
          ></b-form-input>
        </b-form-group>
      </b-col>
 </b-row>

 <b-row  v-if="mercadoPagoSettings != null">

<div>
    <div class="card card-borderless">
      <a-tabs defaultActiveKey="1" class="air-tabs-bordered">
        <a-tab-pane v-if="mercadoPagoSettings.mercadoPagoPos != null" tab="Pix / QrCode" key="1">
          <img :src="mercadoPagoSettings.mercadoPagoPos.qrImage" width="300" />
          <a target="_blank" :href="mercadoPagoSettings.mercadoPagoPos.qrTemplateDocument" class="ml-5">
            <img :src="mercadoPagoSettings.mercadoPagoPos.qrTemplateImage" width="250" />
          </a>
          
          <h5>
            Pix Copia e Cola
          </h5>
          <p>{{mercadoPagoSettings.mercadoPagoPos.qrCode}}</p>
            
          <p>
          <a class="btn btn-primary">
              <span class="fe fe-copy">

              </span>
              <span class="mls"> Copiar</span>
          </a>
          <a target="_blank" :href="mercadoPagoSettings.mercadoPagoPos.qrTemplateDocument" class="btn ml-3">
              <span class="fe fe-download">

              </span>
              <span class="mls"> Fazer Download</span>
          </a>
          </p>
        </a-tab-pane>
        <a-tab-pane v-if="mercadoPagoSettings.integrationLogsLogs != null && mercadoPagoSettings.integrationLogsLogs.length > 0" tab="Histórico de Integração" key="2">
          
          <ul class="integration-logs">
            <li v-for="(log, index) in mercadoPagoSettings.integrationLogsLogs" :key="index"> 

                <p v-if="log.dtCreated"><strong>Data:</strong> {{log.dtCreated}}  </p>
                <p v-if="log.description"><strong>Descrição:</strong>  {{log.description}} </p>
                <p v-if="log.content"><strong>Conteudo:</strong>  {{log.content}} </p>
                <p v-if="log.error"><strong>Erro:</strong>  {{log.error}} </p>

            </li>
          </ul>
          
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>

 </b-row>

    <div class="air__utils__heading mt-5">
      <div class="d-flex justify-content-between">
        <h5>PagSeguro</h5>
      </div>
    </div>

    <b-row cols="2">
      <b-col>
        <b-form-group label="Codigo Ativação:" label-for="totalcommisioning">
         <b-form-input
            id="totalcommisioning"
            type="number"
            :state="true"
            style="color: gray"
            :disabled="false"
            v-model="form.pagSeguroActivationCode"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group label="Email:" label-for="email">
          <b-form-input
            id="email"
            v-model="form.pagSeguroISOUsername"
            required
            placeholder="Email"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="token:" label-for="token">
          <b-form-input
            id="token"
            v-model="form.pagSeguroISOToken"
            required
            placeholder="token"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group label="Url Notificação:" label-for="notificationUrl">
          <b-form-input
            id="notificationUrl"
            v-model="form.pagSeguroISOEndPoint"
            required
            placeholder="notificationUrl"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <hr />

    <div class="row">
      <div class="col-xl">
        <b-btn
          type="submit"
          class="col-md-2"
          variant="outline-primary"
          :disabled="loading"
          >Salvar
          <b-spinner
            small
            variant="primary"
            label="Spinning"
            v-show="loading"
          ></b-spinner>
        </b-btn>
      </div>
    </div>





    

  </b-form>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { get as _get, debounce as _debounce } from "lodash";
import { mask } from "@titou10/v-mask";
import { MerchantConfigResource } from "@/resources/MerchantConfig.resource.js";
import { PayoutTypeResource } from "@/resources/PayoutType.resource.js";

export default {
  directives: { mask },
  props: {
    merchant: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },

  data() {
    return {
      loading: false,
      loadingPayoutType: false,
      payoutTypeList: [],
      mercadoPagoSettings: {},
      form: {
        idMercadoPagoStore: _get(this.merchantConfig, "idMercadoPagoStore", ""),
        idMercadoPagoPos: _get(this.merchantConfig, "idMercadoPagoPos", ""),
        pagSeguroISOUsername: _get(
          this.merchantConfig,
          "pagSeguroISOUsername",
          ""
        ),
        pagSeguroISOToken: _get(this.merchantConfig, "pagSeguroISOToken", ""),
        pagSeguroISOEndPoint: _get(
          this.merchantConfig,
          "pagSeguroISOEndPoint",
          ""
        ),
        pagSeguroActivationCode: _get(
          this.merchantConfig,
          "pagSeguroActivationCode",
          0
        ),
        payoutType: {
          idPayoutType: _get(this.merchant.idPayoutType, null),
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      getConfig: "getConfig",
    }),
    ...mapState(["settings"]),
  },

  created() {
    this.load(this.merchant.idMerchant);
    this.loadPayoutType();
  },
  methods: {
    loadPayoutType() {
      this.loading = true;
      PayoutTypeResource.getKeyValue()
        .then((result) => {
          this.loading = false;
          this.payoutTypeList = result.data.payload;
        })
        .catch((e) => {
          this.loading = false;
        });
    },

    load(idMerchant) {
      this.form.payoutType.idPayoutType = this.merchant.idPayoutType;

      MerchantConfigResource.getById({ idMerchant: idMerchant })
        .then((result) => {
          try {
            this.merchantConfig = result.data.payload;


            this.form.idMercadoPagoStore = _get(
              this.merchantConfig,
              "idMercadoPagoStore",
              ""
            );

            this.form.idMercadoPagoPos = _get(
              this.merchantConfig,
              "idMercadoPagoPos",
              ""
            );

            this.form.pagSeguroISOUsername = _get(
              this.merchantConfig,
              "pagSeguroISOUsername",
              ""
            );
            this.form.pagSeguroISOToken = _get(
              this.merchantConfig,
              "pagSeguroISOToken",
              ""
            );
            this.form.pagSeguroISOEndPoint = _get(
              this.merchantConfig,
              "pagSeguroISOEndPoint",
              ""
            );
            (this.form.pagSeguroActivationCode = _get(
              this.merchantConfig,
              "pagSeguroActivationCode",
              0
            )),
              (this.loading = false);
          } catch (e) {
            throw {
              response: {
                data: {
                  failureReason: "Deu ruim na chamada...",
                },
              },
            };
          }
        })
        .catch((e) => {
          this.loading = false;
          
          if(!this.form.pagSeguroISOEndPoint)
            this.form.pagSeguroISOEndPoint = (this.getConfig.pagSeguroISOTemplate || '').replace("@IdMerchant", idMerchant)

        });

      MerchantConfigResource.getMercadoPagoSettingsById({ idMerchant })
        .then((result) => {
          try {
            this.mercadoPagoSettings = result.data.payload;
          } catch (e) {
            throw {
              response: {
                data: {
                  failureReason: "Deu ruim na chamada...",
                },
              },
            };
          }
        });
        
    },

    savePayoutType() {
      this.loadingPayoutType = true;
      const payoutTypeData = {
        idPayoutType: this.form.payoutType.idPayoutType,
        idMerchant: parseInt(this.$route.params.id),
      };
      PayoutTypeResource.update(payoutTypeData)
        .then((result) => {
          this.loadingPayoutType = false;
          this.$notification["success"]({
            message: "Registro Salvo",
            description: "",
          });
        })
        .catch((e) => {
          this.loadingPayoutType = false;
        });
    },

    async onSubmit(e) {
      e.preventDefault();

      const data = {
        ...this.form,
        idMerchant: parseInt(this.$route.params.id),
      };

      data.pagSeguroActivationCode = parseInt(data.pagSeguroActivationCode);

      this.loading = true;
      MerchantConfigResource.register(data)
        .then((result) => {
          this.loading = false;
          this.$notification["success"]({
            message: "Registro Salvo",
            description: "",
          });
        })
        .catch((e) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="css">
.width-150 {
  width: 150px;
}
.form .is-invalid,
.form .is-valid {
  padding-right: 0;
}

</style>

<style lang="scss">

ul.integration-logs {
  margin: 0;
  padding: 0;
  line-height: 12px;
  font-size: 12px;

  li {
    margin: 0;
    padding: 10px 0 10px;
    display: block;
    border-bottom: 1px solid #ddd;

    &:last-child {
      border: 0 none;
    }

    p {
      margin: 0;
      padding: 0;
    }
  }
}

</style>
